import { useSections } from "@/contexts/classified";
export const useDocumentsSection = () => { var _a; return (_a = useSections()) === null || _a === void 0 ? void 0 : _a.documents; };
